module.exports = __webpack_public_path__ + "img/dropdown-icon.bc80c7d9.svg";